<div class="fundraising-comparison">
  <div class="resource-surface rounded-4 bg-white border p-3 p-md-4">
    <app-fundraiser-scenario
      [scenario]="scenario"
      [donationCountOverride]="state.donationCountOverride"
      presentation="compact"
      (intendedGiftTotalCentsChange)="onIntendedGiftTotalCentsChange($event)"
      (donationCountOverrideChange)="onDonationCountOverrideChange($event)"
    ></app-fundraiser-scenario>

    <div
      *ngIf="hasCustomizedConfigurations"
      class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between gap-2 mt-3"
    >
      <p class="small text-body-secondary mb-0">
        Platform configurations have been changed.
      </p>
      <button
        type="button"
        class="btn btn-link btn-sm fw-semibold px-0"
        (click)="resetComparison()"
      >
        Reset comparison
      </button>
    </div>

    <hr class="my-4" />

    <app-fundraising-explorer-results
      [results]="results"
      [platforms]="availablePlatforms"
      [categories]="categories"
      [detailPageUrls]="detailPageUrls"
      (optionChange)="onOptionChange($event)"
      (quickViewOpened)="onQuickViewOpened($event)"
      (quickViewClosed)="onQuickViewClosed($event)"
      (quickViewFullPageClicked)="onQuickViewFullPageClicked($event)"
      (detailLinkClicked)="onDetailLinkClicked($event)"
    ></app-fundraising-explorer-results>

    <div
      class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-4 pt-4 border-top"
    >
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="copyComparisonLink()"
      >
        Copy comparison link
      </button>
      <p class="small text-body-secondary mb-0" role="status">
        {{ copyStatus }}
      </p>
    </div>

    <p class="visually-hidden" aria-live="polite" aria-atomic="true">
      {{ liveAnnouncement }}
    </p>
  </div>
</div>
